<div class="side-panel">
  <div class="side-panel-header">
    <div class="tabs">
      <ul class="nav">
        <li class="nav-item" *ngFor="let tab of tabs; let i = index">
          <button class="nav-link px-0 pt-0" [class.active]="i === activeTabIndex" (click)="selectTab(i)">
            {{ tab }}
          </button>
        </li>
      </ul>
    </div>
    <button type="button" class="btn-close close-button" aria-label="Close" (click)="closePanel($event)"></button>
  </div>

  <div class="flex-grow-1 table-container">
    <ng-container *ngIf="tableData.length > 0; else noData">
      <table class="custom-table">
        <thead>
          <tr>
            <th *ngFor="let header of tableHeaders">{{ header }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of tableData">
            <td>{{ getDayOfWeek(row) }}</td>
            <td>{{ getFormattedDate(row) }}</td>
          </tr>
        </tbody>
      </table>
    </ng-container>

    <!-- Show message when no holiday data is available -->
    <ng-template #noData>
      <div class="no-data-message">
        {{ noDataMessage }}
      </div>
    </ng-template>
  </div>
</div>